import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { rewardType } from "../list/RewardTypeList";
import { rewardTypeFormValidation } from "../../../../../FormValidations/super-admin/RewardTypeFormValidation";
import { apiClient } from "../../../../../utils/apiClient";
import { setSnackbarDetails } from "../../../../../redux/AuthReducer/AuthSlice";
import AdminInputModel from "../../../../../components/admin-input-modal/AdminInputModal";

type rewardTypeDetailsState = {
  name: string;
};

type editRewardTypeprops = {
  isOpen: boolean;
  details: rewardType | null;
  refreshList: (signal: AbortSignal) => Promise<void>;
  onClose: () => void;
};

const EditRewardType: React.FC<editRewardTypeprops> = ({
  isOpen,
  details,
  refreshList,
  onClose,
}) => {
  const dispatcher = useDispatch();
  const [rewardType, setRewardType] = useState<rewardTypeDetailsState>({
    name: details?.name ?? "",
  });
  //using the following state to store the error messages
  const [errors, setErrors] = useState({});

  //using the following state to show the btnLoader when user create the data
  const [btnLoading, setBtnLoading] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRewardType({
      ...rewardType,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };
  const handleUpdate = async () => {
    let { status, errors } = rewardTypeFormValidation(rewardType);
    setErrors(errors);
    if (!status) {
      setBtnLoading(true);
      try {
        let controller = new AbortController();
        await apiClient?.put<any>(`/reward-type/${details?.id}`, rewardType, {
          signal: controller?.signal,
        });
        await refreshList(controller?.signal);
        onClose();
        dispatcher(
          setSnackbarDetails({
            type: "success",
            message: "Reward type updated successfully!",
          }),
        );
      } catch (error: any) {
        dispatcher(
          setSnackbarDetails({
            type: "error",
            message:
              error?.response?.data?.data?.message ??
              error?.response?.data?.data ??
              "Error in updating the reward type!",
          }),
        );
      } finally {
        setBtnLoading(false);
      }
    }
  };
  return (
    <div>
      <AdminInputModel
        title="Update Reward Type"
        isOpen={isOpen}
        values={rewardType}
        fields={[
          {
            label: "Reward Name",
            placeholder: "Enter Reward Name",
            name: "name",
          },
        ]}
        btnLoading={btnLoading}
        errors={errors}
        onChange={handleChange}
        onSubmit={handleUpdate}
        onClose={onClose}
      />
    </div>
  );
};

export default EditRewardType;
